var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ResponsiveContainer',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('p',[_vm._v(_vm._s(_vm.$t('menu.dashboard')))])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }